import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { InfoCircleOutlined, PlusOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table, Upload, Space } from "antd";
import Filter from "../../../components/filter/Filter";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePerson,
  getPersonByType,
  exportPersons,
} from "../../../redux/slices/persons/personsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { toast } from "react-toastify";
import columns from "./columns";
import CustomModal from "../../../components/modal";
import { uploadOthersFile } from "../../../redux/slices/importOthers/importPersonsThunk";
import ImportComponent from "../../../components/logModal";

const PharmaciesPage = () => {
  const dispatch = useDispatch();
  const persons_data = useSelector((state) => state.persons.persons);
  const persons_loading = useSelector((state) => state.persons.loading);
  const governments_data = useSelector((state) => state.governments.governments);
  const government_loading = useSelector((state) => state.governments.loading);
  const regions_data = useSelector((state) => state.regions.regions);
  const region_loading = useSelector((state) => state.regions.loading);
  const loadingImportation = useSelector((state) => state.uploadOthers.loading);

  const [filter, setFilter] = useState({
    pharmacyType: "",
    region: [],
    government: [],
  });

  const [ids, setIds] = useState({
    region: [],
    government: [],
  });

  const [search, setSearch] = useState({
    region: "",
    government: "",
    searchTerm: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  const [showLog, setShowLog] = useState(false);
  const [exporting, setExporting] = useState(false);

  const handleShowLog = () => {
    setShowLog(!showLog);
  };

  const handlePageChange = (page, pageSize) => {
    setPagination({ pageSize: pageSize, currentPage: page });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);
  const showModal = (id) => {
    setIsModalOpen(true);
    setCitemId(id);
  };

  const refreshPharmaciesList = useCallback(() => {
    dispatch(
      getPersonByType({
        type: 2,
        pageNumber: pagination.currentPage,
        limit: pagination.pageSize,
        filter: {
          pharmacyType: filter.pharmacyType,
          search: search.searchTerm,
          region: ids.region,
          government: ids.government,
        },
      })
    );
  }, [dispatch, pagination, filter, ids, search.searchTerm]);
  
  useEffect(() => {
    refreshPharmaciesList();
  }, [refreshPharmaciesList]);
  
  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 50, search: search.government }));
  }, [search.government, dispatch]);

  useEffect(() => {
    const selectedGovernmentId = ids.government || null;
    dispatch(
      getRegions({
        page: 1,
        itemsPerPage: 50,
        governmentId: selectedGovernmentId,
        search: search.region || "",
      })
    );
  }, [ids.government, search.region, dispatch]);

  const createOptions = (data, labelKey = "name", valueKey = "name", idKey = "id") => {
    return (
      data?.map((item) => ({
        id: item[idKey],
        label: item[labelKey],
        value: item[valueKey],
      })) || []
    );
  };

  const optionsLists = [
    {
      name: "Gouvernorat", placeholder: "Gouvernorat", key: "government", multiple: true, isLoading: government_loading,
      options: createOptions(governments_data?.data, "name", "name"),
    },
    {
      name: "Région", placeholder: "region", key: "region", multiple: true, isLoading: region_loading,
      options: createOptions(regions_data?.data, "name", "name"),
    },
    {
      name: "pharmacyType", placeholder: "Type", key: "pharmacyType", multiple: false,
      options: [{ label: "Tous", value: "" }, { label: "Jour", value: 1 }, { label: "Nuit", value: 2 }],
    },
  ];

  const history = useHistory();
  const naviagteTo = (path) => history.push(path);

  const handelDelete = (id) => {
    dispatch(deletePerson(id)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Pharmacie supprimée avec succès");
        refreshPharmaciesList();
      } else {
        toast.error("Erreur pendant la suppression de la pharmacie");
      }
    });
    setIsModalOpen(false);
  };

  const handleSelect = (value, key, id) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [key]: Array.isArray(value) ? value : [value],
    }));
    setIds((prevId) => ({
      ...prevId,
      [key]: Array.isArray(id) ? id : [id],
    }));
    setPagination((prevPagination) => ({
      ...prevPagination,
      currentPage: 1,
    }));
  };

  const handleSearchedValue = (value, key) => {
    if (search[key] !== value) {
      setSearch((prevSearch) => ({ ...prevSearch, [key]: value }));
      if (key === "searchTerm")
        setPagination((prevPagination) => ({ ...prevPagination, currentPage: 1 }));
    }
  };

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadOthersFile(formData))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Fichier importé avec succès");
          refreshPharmaciesList();
        } else {
          toast.error("Erreur lors de l'importation du fichier");
        }
      })
      .catch((error) => {
        toast.error("Erreur lors de l'importation du fichier", error);
      });
  };

  const handleExport = () => {
    setExporting(true);
    const currentFilters = {
      pharmacyType: filter.pharmacyType,
      search: search.searchTerm,
      region: ids.region,
      government: ids.government,
    };
    dispatch(exportPersons({ type: 2, filter: currentFilters }))
      .then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Le téléchargement de votre fichier va commencer.");
        } else {
          toast.error(`Erreur lors de l'export: ${result.payload}`);
        }
      })
      .catch(() => {
        toast.error("Une erreur inattendue est survenue lors de l'export.");
      })
      .finally(() => {
        setExporting(false);
      });
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des pharmacies"
            extra={
              <Space>
                <Button shape="circle" icon={ loadingImportation ? (<InfoCircleOutlined style={{ color: 'orange' }} />) : (<InfoCircleOutlined />) } onClick={handleShowLog}/>
                <Upload
                  accept=".csv,.json"
                  customRequest={({ file, onSuccess }) => { handleFileUpload(file); onSuccess(); }}
                  showUploadList={false}
                  disabled={loadingImportation}
                >
                  <Button type="primary" icon={<UploadOutlined />} loading={loadingImportation}>Importer</Button>
                </Upload>
                <Button onClick={handleExport} icon={<DownloadOutlined />} loading={exporting}>Exporter</Button>
                <Button type="primary" onClick={() => naviagteTo("/nouvelle/pharmacie")}>
                  <PlusOutlined /> Ajouter un pharmacien
                </Button>
              </Space>
            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                optionsLists={optionsLists}
                onSelect={handleSelect}
                onSearchValue={handleSearchedValue}
                data={filter}
              />
            }
          >
            <Table
              columns={columns(naviagteTo, showModal)}
              dataSource={persons_data?.data}
              loading={persons_loading}
              className="ant-border-space"
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
              pagination={{
                current: pagination.currentPage,
                pageSize: pagination.pageSize,
                total: persons_data?.total,
                onChange: handlePageChange,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
                position: ["topRight", "bottomRight"],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} pharmacies`,
              }}
              scroll={{ x: 240 }}
              rowKey={(record) => record.id}
            />
          </Card>
        </Col>
        <CustomModal
          title="Supprimer un pharmacien"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onClose={() => setIsModalOpen(false)}
          action={() => handelDelete(itemId)}
          actionName={"Supprimer"}
          body={"Êtes-vous sûr de vouloir supprimer ce pharmacien ?"}
        ></CustomModal>
        <ImportComponent visible={showLog} onCancel={handleShowLog}></ImportComponent>
      </Row>
    </div>
  );
};

export default PharmaciesPage;